import { render, staticRenderFns } from "./lay-left.vue?vue&type=template&id=47da16f1&scoped=true"
import script from "./lay-left.vue?vue&type=script&lang=js"
export * from "./lay-left.vue?vue&type=script&lang=js"
import style0 from "./lay-left.vue?vue&type=style&index=0&id=47da16f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47da16f1",
  null
  
)

export default component.exports